import { all, fork, takeLeading, put, call, select } from 'redux-saga/effects'
import {
  createSubscription_action,
  setActiveSubscription_action,
  toggleCheckoutModal_action,
  toggleSubmittingCard_action,
  toggleSubmittingSubscription_action,
  getActiveSubscription_action,
  resumeSubscription_action,
  setInvoices_action,
  toggleInvoiceFetching_action,
  toggleResumePlanModal_action,
  toggleOnboardingPlansPopup_action,
  toggleCreateItemsPopup_action
} from 'store/actions'
import * as types from 'store/types'
import * as apis from 'store/apis'
import { addTrafficSource, consoleLog, handleApiError, logAmplitudeEvent } from 'utils/helpers'

function* getActiveSubscription() {
  try {
    const data = yield call(apis.getActiveSubscription_api)
    yield put(setActiveSubscription_action(data))
  } catch (error) {
    yield put(setActiveSubscription_action(null))
  }
}
function* addCard_action({ data, resolve, reject }) {
  try {
    const showCreateItemPopup = data.showCreateItemPopup
    yield put(toggleSubmittingCard_action(true))
    yield call(apis.createCard_api, data)
    yield put(toggleSubmittingCard_action(false))
    const is_subscribed = yield select((state) => state.subscription.is_subscribed)
    const showResumePlanModal = yield select((state) => state.subscription.showResumePlanModal)
    if (!is_subscribed) {
      yield put(createSubscription_action({ plan: data.plan, showCreateItemPopup }, resolve, reject))
    } else if (showResumePlanModal) {
      yield put(resumeSubscription_action())
    }
    resolve()
  } catch (error) {
    yield put(toggleSubmittingCard_action(false))
    reject(error)
  }
}
function* createSubscription_saga({ data, resolve, reject }) {
  try {
    const showCreateItemPopup = data.showCreateItemPopup
    const isUpgradeStep4 = yield select((state) => state.subscription.isUpgradeStep4)
    yield put(toggleSubmittingSubscription_action(true))
    if (isUpgradeStep4) {
      logAmplitudeEvent('step4 upgrade')
    }
    yield call(apis.createSubscription_api, data)
    yield put(toggleSubmittingSubscription_action(false))
    yield put(toggleCheckoutModal_action(false))
    yield put(toggleOnboardingPlansPopup_action(false))
    if (showCreateItemPopup) {
      yield put(toggleCreateItemsPopup_action(true))
    }
    yield put(getActiveSubscription_action())

    const company = yield select((state) => state.company.company)
    const user = yield select((state) => state.auth.user)
    addTrafficSource('upgrade', company?.name, user?.email)
    resolve()
  } catch (error) {
    yield put(toggleSubmittingSubscription_action(false))
    reject(error)
  }
}
function* updateSubcriptionPlan_saga({ data, resolve, reject }) {
  try {
    yield put(toggleSubmittingSubscription_action(true))
    yield call(apis.switchPlan_api, data)
    yield put(toggleSubmittingSubscription_action(false))
    yield put(toggleCheckoutModal_action(false))
    yield put(getActiveSubscription_action())
    resolve()
  } catch (error) {
    yield put(toggleSubmittingSubscription_action(false))
    reject(error)
  }
}
function* resumeSubscription_saga() {
  try {
    yield put(toggleSubmittingSubscription_action(true))
    yield call(apis.resumeSubscription_api)
    yield put(toggleSubmittingSubscription_action(false))
    yield put(toggleResumePlanModal_action(false))
    yield put(getActiveSubscription_action())
  } catch (error) {
    handleApiError(error)
  }
}
function* fetchInvoices_saga() {
  try {
    yield put(toggleInvoiceFetching_action(true))
    const data = yield call(apis.getInvoices_api)
    yield put(setInvoices_action(data))
  } catch (error) {
    yield put(toggleInvoiceFetching_action(false))
    consoleLog(error)
  }
}

export function* watchSagas() {
  yield takeLeading(types.GET_ACTIVE_SUBSCRIPTION, getActiveSubscription)
  yield takeLeading(types.ADD_CARD, addCard_action)
  yield takeLeading(types.CREATE_SUBSCRIPTION, createSubscription_saga)
  yield takeLeading(types.UPDATE_SUBSCRIPTION, updateSubcriptionPlan_saga)
  yield takeLeading(types.RESUME_SUBSCRIPTION, resumeSubscription_saga)
  yield takeLeading(types.FETCH_INVOICES, fetchInvoices_saga)
}

export default function* subscriptionSaga() {
  yield all([fork(watchSagas)])
}
